<template>
    <div>
        <general :languages="languages" :readOnly="true" class="mt-5"></general>

        <private-descriptifs :languages="languages" :readOnly="true"></private-descriptifs>

        <localisation :read-only="true"></localisation>

        <contacts :contacts="contacts" :read-only="true"></contacts>

        <medias :read-only="true" class="mt-5"></medias>

        <specific :read-only="true" class="mt-5"></specific>

        <opening-hours :read-only="true"></opening-hours>

        <price-periods :read-only="true" class="mt-5"></price-periods>

        <apidae-contacts :professions="professions" :read-only="true"></apidae-contacts>
    </div>
</template>

<script>
import PrivateDescriptifs from "../tabulations/PrivateDescriptifs.vue"
import ApidaeContacts from "../tabulations/ApidaeContacts.vue"
import PricePeriods from "../tabulations/PricePeriods.vue"
import OpeningHours from "../tabulations/OpeningHours.vue"
import Specific from "../tabulations/Specific.vue"
import Medias from "../tabulations/Medias.vue"
import Contacts from "../tabulations/Contacts.vue"
import Localisation from "../tabulations/Localisation.vue"
import General from "../tabulations/General.vue"

export default  {
    name: "SitGlobalAnswerStep",
    components: {
        PrivateDescriptifs,
        ApidaeContacts,
        PricePeriods,
        OpeningHours,
        Specific,
        Medias,
        Contacts,
        Localisation,
        General,
    },
    props: ['languages', 'contacts', 'professions',]
}
</script>
